module.exports = __webpack_public_path__ + "static/history-notification-20c69eab10a384486d6977f920935cad.png";